import { HOME } from "@/constants/testIds";
import { Link } from "react-router-dom";
import {
  Instagram,
  Facebook,
  Youtube,
  MessageCircle,
  Download,
  Apple,
} from "lucide-react";

const cols = [
  {
    title: "Product",
    links: [
      { l: "Home", to: "/" },
      { l: "Features", to: "/features" },
      { l: "Shops", to: "/shops/register" },
      { l: "Marketplace", to: "/#marketplace" },
      { l: "Jobs", to: "/#jobs" },
      { l: "Local Needs", to: "/#local-needs" },
      { l: "Wallet", to: "/#wallet" },
    ],
  },
  {
    title: "Company",
    links: [
      { l: "About Time2Cash", to: "/about" },
      { l: "About DIGISWING", to: "/about-digiswing" },
      { l: "Founding Team", to: "/team" },
      { l: "Ambassador Program", to: "/ambassador" },
      { l: "Careers", to: "/careers" },
      { l: "Blog & Updates", to: "/blog" },
    ],
  },
  {
    title: "Support",
    links: [
      { l: "Help Center", to: "/faq" },
      { l: "FAQs", to: "/faq" },
      { l: "Contact", to: "/contact" },
      { l: "Reviews", to: "/reviews" },
      { l: "Gallery", to: "/gallery" },
      { l: "Quick Links", to: "/links" },
    ],
  },
  {
    title: "Legal",
    links: [
      { l: "Privacy Policy", to: "/privacy" },
      { l: "Terms & Conditions", to: "/terms" },
      { l: "Refund Policy", to: "/refunds" },
      { l: "Account Deletion", to: "/account-deletion" },
    ],
  },
];

const socials = [
  {
    icon: Instagram,
    link: "https://instagram.com/time2cash.co",
    label: "Instagram",
  },
  {
    icon: Facebook,
    link: "https://www.facebook.com/time2cash.co/",
    label: "Facebook",
  },
  {
    icon: Youtube,
    link: "https://youtube.com/@Time2Cash-Co",
    label: "YouTube",
  },
  {
    icon: MessageCircle,
    link: "https://wa.me/919988771606",
    label: "WhatsApp",
  },
  {
    icon: Download,
    link: "https://play.google.com/store/apps/details?id=YOUR_PACKAGE_NAME",
    label: "Google Play",
  },
  {
    icon: Apple,
    link: "https://apps.apple.com/app/idYOUR_APP_ID",
    label: "App Store",
  },
];

export default function Footer() {
  return (
    <footer data-testid={HOME.footerRoot} className="bg-[#1A1918] text-white pt-20 pb-8">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <img
  src="/Media-Library/logo.png"
  alt="Time2Cash Logo"
  className="w-10 h-10 object-contain rounded-sm"
/>
              <span className="font-extrabold text-xl">
                Time<span className="text-[#FF5A00]">2</span>Cash
              </span>
            </Link>
            <p className="mt-4 text-white/70 leading-relaxed text-sm">
              A hyperlocal super-app by DIGISWING Innovation Private Limited — powering everyday city life across India.
            </p>
            <div className="mt-6 flex gap-2 flex-wrap">
  {socials.map(({ icon: Icon, link, label }) => (
    <a
      key={label}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF5A00] hover:scale-110 flex items-center justify-center transition-all duration-300"
    >
      <Icon className="w-5 h-5" />
    </a>
  ))}
</div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-sm font-bold text-white">{c.title}</div>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.l + l.to}>
                    <Link to={l.to} className="text-sm text-white/60 hover:text-[#FF5A00] transition">
                      {l.l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <a
  href="https://digiswing.com"
  target="_blank"
  rel="noopener noreferrer"
  className="text-xs text-white/50 hover:text-[#FF5A00] transition-colors"
>
  © {new Date().getFullYear()} DIGISWING Innovation Private Limited. All rights reserved.
</a>
          <div className="text-xs text-white/50">Made with care in India · hello@time2cash.co</div>
        </div>
      </div>
    </footer>
  );
}
